import InputWrapper from "../../../../../../components/input/wrapper/InputWrapper";
import Select from "../../../../../../components/select/main/Select";
import { useLanguageContext } from "../../../../../../context/LanguageContext";
import EVAApiHelper from "../../../../../../helpers/EVAApiHelper";
import { StyledFlexColumn } from "../../../../../../styles/LayoutStyles";

function ReferenceCheckFormView({
  relations,
  selectedStep,
  selectedStepIndex,
  onReferenceFieldChange,
  submitError,
}) {
  const { translate, translateEntity } = useLanguageContext();

  return (
    <StyledFlexColumn>
      <InputWrapper
        label={translate(
          "eva.main.validation.attributes.steps.*.reference_field_id",
        )}
        error={EVAApiHelper.getResponseError(
          `steps.${selectedStepIndex}.reference_field_id`,
          submitError,
        )}
      >
        <Select
          value={selectedStep?.reference_field_id}
          options={relations?.fields?.records?.map((field) => ({
            label: translateEntity(field, "label"),
            value: field.id,
          }))}
          nullable
          onChange={onReferenceFieldChange}
        />
      </InputWrapper>
    </StyledFlexColumn>
  );
}

export default ReferenceCheckFormView;